import React from "react";
import BlogTwentyTwo from "../component/BlogTwentyTwo";

function BlogTwentyTwoContainer() {
  return <BlogTwentyTwo />;
}
export default BlogTwentyTwoContainer;
